
<template>
  <div class="zc loginbody">
    <div class="main">
      <div class="new-register-box">
        <div class="topLogin">
          <img :src="BASEURL+'static/logo.png'" alt="">
          <span>{{ APP_WINNY_NAME }}</span>
        </div>
        <div class="popupQR">
          <vue-qr id="picture" class="qrcode" :text="registerUrl" :margin="3" color-dark="#000" color-light="#fff" :dot-scale="1" :size="260"></vue-qr>
        </div>
        <div class="codeTip">请使用微信扫码注册</div>
        <div class="bottomRouter">
          <span class="loginTipf">已有账号？</span>
          <span class="roLogin">
            <router-link tag="a" to="/login">登录</router-link>
          </span>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

import vueQr from 'vue-qr'

export default {
  name: 'Register',
  components: {

    vueQr
  },

  data() {
    return {
      APP_WINNY_NAME: window.g.APP_TITLE_ALL,
      BASEURL: process.env.BASE_URL,
      registerUrl: window.g.REGISTER_URLS_CODE
    }
  }
}
</script>
<style scoped lang="scss">
 @import  '../../../assets/images/main.min.css';
 @import  '../../../assets/images/servicecenter.min.css';
 .main{
  height: calc(100vh - 40px);
 }
 .qx span{color: #000000;}
 .new-register-box{
    background: #fff;
    // opacity: .8;
    position: absolute;
    left: calc(50% - 372px);
    top: 10%;
    // width: 500px;
    width: 730px;
    border-radius: 12px;
    .coinbig-nasq{
        padding-top:30px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #171C23;
      }
  .popupQR{
      display: flex;
      justify-content: center;
      align-items: center;

  }
  .codeTip{
    margin-top:40px;
    font-size:20px;
    text-align:center;
    color: #171C23;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
;
  }
  .bottomRouter{
    margin:20px auto;
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #9AA5B3;
  }
  .roLogin a{
      font-size: 18px;
     color: #2483FF;
  }
 }
  .topLogin{
    width: 350px;
    padding: 10px 0;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 100px;
    }
    span{
      font-size:30px;
      color:#000000;
      font-weight: bold;
    }
  }
.dialogBtn {
  // height: 40px;
  line-height: 40px;
  width: 40%;
}
.leftButton{
  float: left;
}
</style>
<style>
/* .loginbody .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
  background-color: #4e5985 !important;
} */
   .qx span{color: #000000;}
  .loginbody {

          /* background: url(../../../assets/images/loginBg.jpg) center center/cover no-repeat #1A2446; */
          background-size: 100% 100%;
    }
.country{padding: 10px;}
#login .el-input__inner {
 color: rgba(0,0,0,0.8);
  width: 100%;
  height: 100%;
  /* padding: 8px 8px 8px 10px; */
  height: 48px;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 4px;
  border: 1px solid #979797;
  background: #fff;
  cursor: pointer;
}
#login .el-form-item__error{

}
 #login .isAgree .el-form-item__content{
   line-height: 10px;
 }

 #login .el-form-item__content {
line-height:40px;
}
 #login .imgYzmInput .el-input-group__append {
    width: 35%;
    padding:0;
    border:none;
    background: none;
}

 #login .el-input-group{
  height: 40px;
}
 #login .imgYzm {
   border-radius:0 2px 2px 0;
height: 40px;
margin-top: 1px;
  width: 100%;
  cursor: pointer;
}
#login .el-button--primary:hover, #login .el-button--primary:focus, #login.el-button:hover {

     background: linear-gradient(90deg,#2577e1,#3bb0e3,#4edcf5);
}
 #login .el-form-item__content{
  line-height: 40px;
}
 #login .el-select {
        width: 100%;
        }
  #login  .forget{
     float: right;

     color: rgb(69, 142, 255);
     }
  .selectcountry{
    background-color: #15284c;
    border: none;
    padding: 10px;
  }
.selectcountry .el-select-dropdown__item.hover, .selectcountry .el-select-dropdown__item:hover {
    background-color: #F5F7FA;
}

.selectcountry .el-select-dropdown__item.hover{background:#495689}
.selectcountry .el-select-dropdown__item span{
  color:#dfdfdf;
}
#selectcountry .el-scrollbar .el-tooltip__popper[x-placement^=bottom] .popper__arrow{
      border-bottom-color: red;
    }
#selectcountry .el-scrollbar .el-tooltip__popper[x-placement^=bottom] .popper__arrow:after {
      border-bottom-color: red;
    }
</style>
